<!--
    Styles
-->

<style>

    .ui-map .gm {
        height: 100%;
    }

    .ui-map .gm-style {
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;
    }

</style>


<!--
    Template
-->

<template>
    <div class="ui-map">
        <div class="gm" ref="map" />
        <div ref="overlay"><slot /></div>
    </div>
</template>


<!--
    Scripts
-->

<script>


    import maps from '@/common/modules/maps'

    const heatMapOptions = {
        radius: 30,
        opacity: 0.3
    };

    export default {

        props: [
            'options',
            'view',
            'bounds',
            'markers',
            'heatPoints'
        ],

        data () {
            return {
                store: []
            }
        },

        methods: {

            idle () {
                const bounds = this.map.getBounds();
                const {lat, lng, zoom} = this.map.getView();
                this.$emit('idle', {lat, lng, zoom, bounds: bounds.toJSON()});
            },

            setHeatMap () {
                if (!this.heatPoints) return this.heatMap.setMap(null);
                this.heatMap.setMap(this.map);
                this.heatMap.setData(this.heatPoints.map(point => ({
                    location: new maps.LatLng(point.location[0], point.location[1]),
                    weight: point.weight
                })));
            },

            setMarkers () {
                this.store.forEach(marker => marker.setMap(null));
                if (!this.markers) return (this.store = []);
                this.store = this.markers.map(marker => new maps.Marker({...marker, map: this.map}));
            },

            setBounds () {
                const {south, west, north, east} = this.bounds;
                this.map.fitBounds(new maps.LatLngBounds(
                    {lat: south, lng: west},
                    {lat: north, lng: east}
                ));
            },

            setView () {
                const {lat, lng, zoom} = this.map.getView();
                if (this.view.lat !== lat || this.view.lng !== lng) this.map.setCenter({lat: this.view.lat, lng: this.view.lng});
                if (this.view.zoom !== zoom) this.map.setZoom(this.view.zoom);
            }

        },

        watch: {

            view () {
                this.setView();
            },

            bounds () {
                this.setBounds();
            },

            heatPoints () {
                this.setHeatMap();
            },

            markers () {
                this.setMarkers();
            }

        },


        mounted () {
            this.map = new maps.Map(this.$refs.map, this.options);
            if (this.bounds) this.setBounds();
            if (this.view) this.setView();
            this.map.addListener('idle', this.idle);
            this.map.addListener('zoom_changed', event => this.$emit('zoom', event));
            this.map.addListener('click', event => this.$emit('click', event));
            this.overlay = new maps.Overlay(this.$refs.overlay, this.map);
            this.$el.removeChild(this.$refs.overlay);
            this.heatMap = new maps.visualization.HeatmapLayer(heatMapOptions);
            this.setHeatMap();
            this.setMarkers();
        },

        destroyed () {
            this.overlay.setMap(null);
            this.heatMap.setMap(null);
            this.store.forEach(marker => marker.setMap(null));
            maps.event.clearInstanceListeners(this.map);
        }

    }

</script>

